import { useCallback, useInsertionEffect, useRef } from 'react';

/**
 * A function that keeps its identity across renders but always calls the latest `fn` (like React's
 * `useEffectEvent`, for event handlers). Lets memoized children skip re-rendering when only a
 * handler's closure changed. Not for calling during render.
 */
export function useStableCallback<A extends unknown[], R>(fn: (...args: A) => R): (...args: A) => R {
  const latest = useRef(fn);
  useInsertionEffect(() => {
    latest.current = fn;
  });
  return useCallback((...args: A) => latest.current(...args), []);
}
